import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const STORAGE_KEY = "rythugaru-cookie-consent";

/**
 * Small, dismissible cookie notice shown until the visitor makes a choice.
 * The choice is remembered in localStorage so it only appears once.
 */
export default function CookieConsent() {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!window.localStorage.getItem(STORAGE_KEY)) {
        setVisible(true);
      }
    } catch {
      setVisible(true);
    }
  }, []);

  const dismiss = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, "accepted");
    } catch {
      // Storage unavailable — just hide for this session.
    }
    setVisible(false);
  };

  // Visitor-facing notice — never shown inside the staff admin portal.
  if (pathname.startsWith("/admin")) {
    return null;
  }

  if (!visible) {
    return null;
  }

  return (
    <div className="fixed z-[60] bottom-4 left-4 right-4 md:left-6 md:right-auto md:bottom-6 md:w-[26rem]">
      <div className="bg-foreground-950 text-background-50 border border-foreground-800 rounded-lg px-4 py-4 md:px-5 md:py-5">
        <div className="flex items-start gap-3">
          <span className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-500 text-background-50 shrink-0">
            <i className="ri-shield-check-line text-lg"></i>
          </span>
          <div className="flex-1">
            <p className="font-heading text-sm md:text-base font-semibold text-background-50">
              We use cookies
            </p>
            <p className="text-xs md:text-sm text-background-300 leading-relaxed mt-1">
              We use cookies to keep the site working and to understand how it is used. See our{" "}
              <Link
                to="/privacy"
                className="text-accent-300 font-semibold underline underline-offset-2 hover:text-accent-200 transition-colors"
              >
                Privacy Policy
              </Link>{" "}
              for details.
            </p>
            <div className="flex items-center gap-2 mt-3">
              <button
                type="button"
                onClick={dismiss}
                className="inline-flex items-center gap-1.5 bg-accent-500 text-background-50 text-xs md:text-sm font-semibold px-4 py-2.5 rounded-md hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Accept
              </button>
              <button
                type="button"
                onClick={dismiss}
                className="inline-flex items-center bg-foreground-800 text-background-100 text-xs md:text-sm font-semibold px-4 py-2.5 rounded-md hover:bg-foreground-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                Decline
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}